import { Circle, G, Path, Rect, Svg } from "react-native-svg";

import { useTheme } from "~/styles/theme";

/**
 * The GearSync logomark. Generated from the same geometry as the app
 * icon and the website favicon, so the three surfaces cannot drift apart.
 * Colours are the brand's own — a mark should not follow semantic tokens.
 */
const schemes = {
  light: { plate: "#f4f1ea", ink: "#3d5a80", accent: "#e8a838" },
  dark: { plate: "#1c2321", ink: "#d7e2f0", accent: "#e8a838" },
} as const;

export function Logomark({ size = 26 }: { size?: number }) {
  const { scheme } = useTheme();
  const c = schemes[scheme === "dark" ? "dark" : "light"];
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      accessibilityLabel="GearSync"
    >
      <Path
        d="M27 11 H49 A5 5 0 0 1 54 16 V49 A5 5 0 0 1 49 54 H19 A5 5 0 0 1 14 49 V24 Z"
        fill={c.ink}
        strokeLinejoin="round"
      />
      <Circle
        cx="24"
        cy="21"
        r="4"
        fill={c.plate}
        stroke={c.accent}
        strokeWidth="2"
      />
      <Rect x="22" y="32" width="24" height="5" rx="2.5" fill={c.plate} />
      <Rect x="22" y="42" width="15" height="5" rx="2.5" fill={c.plate} />
    </Svg>
  );
}
